
import {
  Component, Prop, Vue,
} from 'nuxt-property-decorator'
import type { RichTextElement } from 'fsxa-api'
import { globalLabel, globalLabelAsString } from '../../shared/general/services/StoreService'
import GlobalLabelWrapper from '../GlobalLabelWrapper.vue'
import BaseIcon from '../base/BaseIcon.vue'
import BaseLink from '../base/BaseLink.vue'
import type { TGptHealthResponse } from '../../shared/general/types/GptHub'
import { Logger } from '../../shared/general/logger/Logger'
import { nuxt } from '../../shared/general/logger/LogKey'
import GptConversationStarters from './GptConversationStarters.vue'

@Component({
  name: 'GptWelcome',
  components: {
    GptConversationStarters,
    BaseIcon,
    BaseLink,
    GlobalLabelWrapper,
  },
})
export default class GptWelcome extends Vue {
  @Prop({ default: () => [] }) conversationStarters! : string[]

  private available : boolean = true

  async mounted () {
    await this.checkHealth()
  }

  private get gptHubIntroLabel () : string {
    return globalLabelAsString('gpt_hub_intro_label')
  }

  private get gptHubUnavailableErrorLabel () : string | RichTextElement[] {
    return globalLabel('gpt_hub_unavailable_error_label')
  }

  private async checkHealth () : Promise<void> {
    this.available = true

    try {
      const response = await fetch('/api/gptHub/health')
      const data : TGptHealthResponse = await response.json()
      this.available = data?.status === 'healthy'
    } catch (error) {
      Logger.error(nuxt, 'Health check failed for GPT Hub', error)
      this.available = false
    }
  }
}
